import React from 'react'
import PropTypes from 'prop-types'

/**
 * Author: Aman Mishra
 * Class Name: Login
 * Created On: Sept 8, 2017
 * Created For: load interface to transfer all the collection to other data
 */
class Alert extends React.Component {
  render () {
    const type = `alert alert-${this.props.type}`
    const message = this.props.message
    return (
      <div>
        <div id="show_msg">
          <div className={type}>{message}</div>
        </div>
      </div>
    )
  }
}

Alert.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string
}

export default Alert
